import * as React from "react";
const SvgSquare = (props) => /* @__PURE__ */ React.createElement("svg", { width: 36, height: 36, viewBox: "0 0 36 36", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 1, y: 1, width: 34, height: 34, rx: 8, stroke: "currentColor", strokeWidth: 2 }));
export default SvgSquare;
